import {useContext} from "react";
import FilterContext from "../../Context/FilterContext";
import ListboxSelect from "./ListboxSelect";

const radiuses = () => {
    const optionsCount = 10;
    const options = [
        {
            value: '*',
            label: 'Rayon'
        }
    ];

    for (let i = 1; i <= optionsCount; i++) {
        const value = i * 10

        options.push({
            value: value,
            label: value + ' km'
        })
    }

    return options
}

const RadiusesSelect = props => {
    const { onChange } = props
    const { radius } = useContext(FilterContext)

    const value = {
        label: radius ? radius + ' km' : 'Rayon',
        value: radius ?? '*'
    }

    return (
        <ListboxSelect items={radiuses()} handleChange={onChange} value={value}/>
    )
}

export default RadiusesSelect